import {EvoAppsUserInfoTO} from 'generated/JavaTO';
import {createAction} from 'util/redux';
import {SessionInfoExpandedStateType} from 'module/SessionInfo/type/SessionInfoType';

const NAMESPACE = 'SESSION_INFO/'
export const sessionInfoSetAction = createAction<EvoAppsUserInfoTO | null>(NAMESPACE + 'SET');
export const sessionInfoExpandAction = createAction<{ name: keyof SessionInfoExpandedStateType, expanded: boolean }>(NAMESPACE + 'expandPanel')
